import { useLoginStore } from "./stores/login.js";


export default {
  projectVersion: "v1.3.2-beta.1",
  // proxy: "http://localhost:3000/",
  proxy: "",
  currentEnv: import.meta.env.VITE_BUILDENV,
  mock: false,
  tenant: null,
  environment: {
    dev: {
      smegcons: {
        api: {
          hostname: "https://smegcons-dashboard.dev-platform.smegconnect.com/api/v1",
          socket: "https://ws.dev-platform.smegconnect.com",
          labels: "https://smegcons.dev-platform.smegconnect.com/api/v1/bloomreach/label"
        },
      },
      smeg: {
        api: {
          hostname: "https://smeg-dashboard.dev-platform.smegconnect.com/api/v1",
          socket: "https://ws.dev-platform.smegconnect.com",
          labels: "https://smeg.dev-platform.smegconnect.com/api/v1/bloomreach/label"
        },
      },
      sda: {
        baseUrl: "https://d3ecp3wve83d1l.cloudfront.net"
      },
    },
    staging: {
      smegcons: {
        api: {
          hostname: "https://smegcons-dashboard.dev-platform.smegconnect.com/api/v1",
          socket: "https://ws.dev-platform.smegconnect.com",
          labels: "https://smegcons.dev-platform.smegconnect.com/api/v1/bloomreach/label"
        },
      },
      smeg: {
        api: {
          hostname: "https://smeg-dashboard.dev-platform.smegconnect.com/api/v1",
          socket: "https://ws.dev-platform.smegconnect.com",
          labels: "https://smeg.dev-platform.smegconnect.com/api/v1/bloomreach/label"
        },
      },
      sda: {
        baseUrl: "https://d3ecp3wve83d1l.cloudfront.net"
      },
    },
    prod: {
      smegcons: {
        api: {
          hostname: "https://smegcons-dashboard.prod-platform.smegconnect.com/api/v1",
          socket: "https://ws.prod-platform.smegconnect.com",
          labels: "https://smegcons.prod-platform.smegconnect.com/api/v1/bloomreach/label"
        },
      },
      smeg: {
        api: {
          hostname: "https://smeg-dashboard.prod-platform.smegconnect.com/api/v1",
          socket: "https://ws.prod-platform.smegconnect.com",
          labels: "https://smeg.prod-platform.smegconnect.com/api/v1/bloomreach/label"
        },
      },
      sda: {
        // baseUrl: "https://d8okvouaz84c6.cloudfront.net"
        baseUrl: "https://mysmeg.smeg.com"
      },
    },
    api: {
      login: "/auth/token", // --> OK
      user: "/dashboard/user", // --> --> OK
      appliance: "/dashboard/device", // --> OK
      refresh_token: "/auth/refreshToken", // --> OK
      logout: "/auth/logout", // --> OK
      first_access: "/first-access", // DA ELIMINARE
      campaigns: "/dashboard/fota/campaigns", // --> OK
      groups: "/dashboard/fota/groups", // --> OK
      csv: "/dashboard/fota/campaign/{{campaignId}}/report", // --> OK
      createCampaign: "/dashboard/fota/campaign", // --> OK
      campaign: "/dashboard/fota/campaign", // --> OK
      deleteCampaign: "/dashboard/fota/campaign", // --> OK
      stopCampaign: "/dashboard/fota/campaign/{{campaignId}}/stop", // --> OK
      updateCampaign: "/dashboard/fota/campaign", // --> OK
      single_group: "/dashboard/fota/group", // --> OK
      updateGroup: "/dashboard/fota/group", // --> OK
      groupsForCampaign: "/dashboard/fota/campaign/groups", // --> OK
      listFirmware: "/dashboard/fota/firmware",  // --> OK
      createGroup: "/dashboard/fota/group", // --> OK
      deleteGroup: "/dashboard/fota/group", // --> OK
      firmware_history: "/dashboard/device/{{deviceCode}}/firmware", // --> OK
      firmware_update: "/dashboard/device/{{deviceCode}}/management", // --> OK
      abac: "/dashboard/abac", // --> OK
      listPdfs: "/dashboard/reports", // --> OK
      listSnapshots: "/dashboard/snapshot-kpis", // --> OK
      saveSnapshot: "/dashboard/snapshot-kpis", // --> OK
      deleteSnapshot: "/dashboard/snapshot-kpis", // --> OK
      map: "/dashboard/device/map", // --> OK
      unclaim_device_admin: "/dashboard/device/{{deviceCode}}/unclaiming", // --> OK
      delete_user_admin: "/dashboard/enduser/deregister", // ??
      listTags: "/dashboard/tag/read", // --> OK
      deleteTag: "/dashboard/tag/delete", // --> OK
      createTag: "/dashboard/tag/add", // --> OK
      associateTag: "/dashboard/tag/associate", // --> OK
      disassociateTag: "/dashboard/tag/disassociate", // --> OK
      chart: "/kpi", // --> OK
      personalInfo: "/dashboard/user/{{userCode}}/info", // --> OK
      dealers: "/dashboard/getDealers",
      approve_dealer: "/dashboard/approveDealer",
      verbose_appliances: "/dashboard/device/verbose",
      pageStatistics: "/kpi/kpi_sda_09",
    },
  },
  env() {
    // console.log("CONFIG TENANT", useLoginStore().getTenant)
    return this.environment[this.currentEnv][useLoginStore().getTenant];
  },
  url(endpoint, full_url = false) {
    // let proxy = (this.currentEnv === 'dev') ? this.proxy : '';
    let url = "";
    if (!full_url) {
      // proxy = proxy + this.env().api.hostname + this.environment.api[endpoint];
      url = this.proxy + this.env().api.hostname + this.environment.api[endpoint];
    } else {
      // proxy = proxy + this.env().api.full_url[endpoint];
      url = this.proxy + this.env().api.full_url[endpoint];
    }
    return url;
  },
  urlOnTenant(endpoint, tenant) {
    return this.proxy + this.environment[this.currentEnv][tenant].api.hostname + this.environment.api[endpoint];
  },
  headers(accesstoken) {
    return {
      'Authorization': `Bearer ${accesstoken}`
    };
  },
  labels(tenant) {
    if (tenant == null) {
      return this.env().api.labels;
    } else {
      return this.proxy + this.environment[this.currentEnv][tenant].api.labels;
    }
  },
  getSdaUrl() {
    return this.environment[this.currentEnv].sda.baseUrl;
  }
}
